{
    "Profile_Dwellings_WaterMitigationSystem.waterMitigationSystem": "Water Mitigation System",
    "Profile_Dwellings_WaterMitigationSystem.waterMitigationDetails": "Water Mitigation Details",
    "Profile_Dwellings_WaterMitigationSystem.sumpPumpType": "Sump Pump Type",
    "Profile_Dwellings_WaterMitigationSystem.backupValveType": "Backup Valve Type",
    "Profile_Dwellings_WaterMitigationSystem.auxiliaryPower": "Auxiliary Power",
    "Profile_Dwellings_WaterMitigationSystem.connectedToAlarm": "Connected To Alarm",
    "Profile_Dwellings_WaterMitigationSystem.primary": "Primary"
}
